<template>

  <div id="app">

    <headerapp></headerapp>

    <section class="section template-horizontal">

      <sidebar-dos></sidebar-dos>
      <div class="container is-fullhd ">
        <!-- <sidebar></sidebar> -->

        <div class="container main">
          <router-view></router-view>
        </div>

      </div>
    </section>

  </div>

</template>

<script>
import Sidebar from './Sidebar'
import SidebarV2 from './SidebarV2'
import Header from './Header'

export default {
  components: {'sidebar': Sidebar, 'headerapp': Header, 'sidebar-dos': SidebarV2}
}
</script>

<style scoped lang="scss">
.template-horizontal {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue